<template>
<svg viewBox="0 0 18 18" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-guanliandanwei`]" width="1em" height="1em" v-bind="$attrs"><path d="M10.6125 2.25H3.6375C2.8875 2.25 2.25 2.925 2.25 3.75V9.75C2.25 10.575 2.8875 11.25 3.6375 11.25H4.875C5.1 11.25 5.25 11.1 5.25 10.875V10.125C5.25 9.9 5.1 9.75 4.875 9.75H4.425C4.05 9.75 3.75 9.4125 3.75 9V4.5C3.75 4.0875 4.05 3.75 4.425 3.75H9.825C10.2 3.75 10.5 4.0875 10.5 4.5V9C10.5 9.4125 10.2 9.75 9.825 9.75H8.625C8.4 9.75 8.25 9.9 8.25 10.125V10.875C8.25 11.1 8.4 11.25 8.625 11.25H10.6125C11.4 11.25 12 10.575 12 9.75V3.75C12 2.925 11.3625 2.25 10.6125 2.25Z"/><path d="M14.3625 6.75H13.125C12.9 6.75 12.75 6.9 12.75 7.125V7.875C12.75 8.1 12.9 8.25 13.125 8.25H13.575C13.95 8.25 14.25 8.5875 14.25 9V13.5C14.25 13.9125 13.95 14.25 13.575 14.25H8.175C7.8 14.25 7.5 13.9125 7.5 13.5V9C7.5 8.5875 7.8 8.25 8.175 8.25H9.375C9.6 8.25 9.75 8.1 9.75 7.875V7.125C9.75 6.9 9.6 6.75 9.375 6.75H7.3875C6.6 6.75 6 7.425 6 8.25V14.25C6 15.075 6.6375 15.75 7.3875 15.75H14.3625C15.15 15.75 15.75 15.075 15.75 14.25V8.25C15.75 7.425 15.1125 6.75 14.3625 6.75Z"/></svg>
</template>
<script>

export default {
  name: 'IconGuanliandanwei',
  props: {
    prefix: {
        type: String,
        default: 'zhilv',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
